import { render, staticRenderFns } from "./notiPopup.vue?vue&type=template&id=3b68176c&scoped=true&"
import script from "./notiPopup.vue?vue&type=script&lang=js&"
export * from "./notiPopup.vue?vue&type=script&lang=js&"
import style0 from "./notiPopup.vue?vue&type=style&index=0&id=3b68176c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b68176c",
  null
  
)

export default component.exports